"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterBodyButton = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DateFilterBodyButtonComponent = function (props) { return (react_1.default.createElement(sdk_ui_kit_1.Button, { type: "button", value: props.intl.formatMessage({ id: props.messageId }), className: props.className, disabled: props.disabled, onClick: props.onClick })); };
exports.DateFilterBodyButton = react_intl_1.injectIntl(DateFilterBodyButtonComponent);
//# sourceMappingURL=DateFilterBodyButton.js.map